import api from '../api/client';

const getDashboardStats = async () => {
    const res = await api.get('/api/dashboard/stats');
    return res?.data?.data;
};

const getAppStats = async (limit = 10) => {
    const res = await api.get('/api/dashboard/app-stats', { params: { limit } });
    return res?.data?.data;
};

const getTopApps = async () => {
    const res = await api.get('/api/dashboard/top-apps');
    return res?.data?.data;
};

const getDashboardOverview = async () => {
    const res = await api.get('/api/dashboard/overview');
    return res?.data?.data;
};

const getAnalytics = async () => {
    const res = await api.get('/api/dashboard/analytics');
    return res?.data?.data;
};

const getReports = async (type = 'all', limit = 100) => {
    const res = await api.get('/api/dashboard/reports', { params: { type, limit } });
    return res?.data?.data;
};

// Optional appId scopes to that app's active members; omitted = every active account.
const getAccountHealth = async (appId) => {
    const res = await api.get('/api/dashboard/account-health', { params: appId ? { app_id: appId } : {} });
    return res?.data?.data;
};

const dashboardService = {
    getDashboardStats,
    getAppStats,
    getTopApps,
    getDashboardOverview,
    getAnalytics,
    getReports,
    getAccountHealth,
};

export default dashboardService;
